import React from 'react';
import CmsRender from '@/components/component-pool/component-ssr/CmsRender';
import { getHomePageDataByUrl } from '@/api/content';
import { ICms } from '@/types/cms';
import { CmsComponentKeys } from '@/components/component-pool';
interface StudentCmsSectionProps {
  sections: any[];
  datasource: any;
  staticRes: any;
  trackingContext: any;
}

const StudentCmsSection: React.FC<StudentCmsSectionProps> = ({ sections, datasource, staticRes, trackingContext }) => {
  const hasValidComponents = Array.isArray(sections) && sections.length > 0;

  if (!hasValidComponents) {
    return null;
  }

  return (
    <CmsRender
      sections={sections}
      datasource={datasource}
      staticRes={staticRes}
      trackingContext={trackingContext}
      statusBarHeight={0}
    />
  );
};

export default StudentCmsSection;

export const findStaicDataFetch = async ({
  sections,
  datasource,
  fetchParams,
  ctx
}: {
  sections: ICms['layout']['sections'];
  datasource: ICms['datasource'];
  fetchParams: { [key: string]: string };
  ctx: any;
}) => {
  let fetchPromises = [];
  let datasourceKeys = [];

  // 辅助函数来递归处理组件（包括 sub_components）
  const processComponent = (component: any) => {
    if (
      component.component_key === CmsComponentKeys.CM_ITEM_LIST ||
      component.component_key === CmsComponentKeys.CM_BANNER_CONTAINER ||
      component.component_key === CmsComponentKeys.CM_FEATURED_PRODUCT
    ) {
      const datasourceKey = component.datasource[0];
      const fetchPromise = getHomePageDataByUrl(
        datasource[datasourceKey].now,
        {
          ...fetchParams,
          dataobject_key: datasourceKey
        },
        { ctx }
      );
      fetchPromises.push(fetchPromise);
      datasourceKeys.push(component.component_instance_key);
    }

    // 处理 sub_components
    if (component.sub_components && Array.isArray(component.sub_components)) {
      for (let subComponent of component.sub_components) {
        processComponent(subComponent);
      }
    }
  };

  for (let section of sections) {
    for (let component of section.components) {
      processComponent(component);
    }
  }

  const results = await Promise.all(fetchPromises);
  const staticRes = results.reduce((acc, result, index) => {
    const key = datasourceKeys[index];
    acc[key] = result;
    return acc;
  }, {});
  return staticRes;
};
